module.exports = __webpack_public_path__ + "static/assets/d7b5f8ce0a08fcbce1520b0e408cafc7.svg";